var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarDays = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#021854",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-calendar-days"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 2v4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2v4"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 4,
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 10h18"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14h.01"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M12 14h.01"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M16 14h.01"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M8 18h.01"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M12 18h.01"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M16 18h.01"
})));
export { SvgCalendarDays as ReactComponent };
export default __webpack_public_path__ + "c41c230753b9032d4490352b21750e5a.svg";